import { computed } from 'vue';
import { pipe } from '@vaaas/fpts/function';
import { every, zip } from '@vaaas/fpts/iter';
import { Edge, Vertex } from '@phi/jcore';
import state from '../';
import { uil_get_vertices_of_edge } from '../../ui_logic';
import { clipping_model_editable, clipping_on } from '@features/clipping';

const all_vertices_belong_in_edges = computed(() => {
    state.selected_edges_count + state.selected_vertices_count;
    return pipe(
        zip<Edge, Vertex>(uid_selected_edges.keys())(uid_selected_vertices.keys()),
        every(([eid, vid]) =>
            uil_get_vertices_of_edge(eid).includes(vid)),
    );
});

export const disabled = computed(() =>
    !state.loaded
    || state.editing_reference_partstudio
    || state.editing_reference_sketches
    || state.editing_reference_stl
    || state.rigid_move_manipulator
    || (
        clipping_on.value
        && !clipping_model_editable.value
    )
    || state.adding_vertex
    || !(
        state.selected_edges_count > 1
        && state.selected_vertices_count === state.selected_edges_count
        && all_vertices_belong_in_edges
    )
    || state.setting_symmetry_plane
    || state.setting_mirror_plane
    || state.selecting_tangent_perpendicular_plane
    || state.currently_loading_model
    || !uid_faces
    || uid_faces.length === 0
    || state.offset_face_selecting_vertex
    || state.offset_face_dragging
);
